import { render, staticRenderFns } from "./uploadNew2.vue?vue&type=template&id=5196ad2f&scoped=true&"
import script from "./uploadNew2.vue?vue&type=script&lang=js&"
export * from "./uploadNew2.vue?vue&type=script&lang=js&"
import style0 from "./uploadNew2.vue?vue&type=style&index=0&id=5196ad2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5196ad2f",
  null
  
)

export default component.exports